import React from "react";
import ReactDOM from "react-dom";
import _ from "lodash";
import "antd/dist/antd.css";
import "../../views/Envelops/style.css";
//import '@ant-design/compatible/assets/index.css';
import { Table, Input, Button, Space, Modal, Divider } from "antd";
import ExportCSV from "./ExportCSV";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import moment from "moment";

class PaginatedDataTable extends React.Component {
  state = {
    searchText: "",
    searchedColumn: "",
    modalVisible: false,
    moreInfo: [],
    sortedInfo: null,
    sortedCount: 0,
  };

  setModalVisible = async (modalVisible, record) => {
    await this.getMoreInfoSource(record);
    this.setState({ modalVisible: modalVisible });
  };

  setModalClose = () => {
    this.setState({ modalVisible: false });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 100 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };
  onChangeTable = async (pagination, filters, sorter, extra) => {
    this.setState({
      sortedInfo: sorter,
      sortedCount: extra.currentDataSource.length,
    });
  };
  renderColumn = (value) => {
    const response = value.map((item, i) => {
      return <p key={i}>{item}</p>;
    });
    const obj = {
      children: response,
      props: {},
    };
    return obj;
  };

  getMoreInfoSource = async (record) => {
    let buffer = [];
    let element = record;
    let temp_a = element.groups.map((item) => {
      return {
        groupOrInvidualName: item.name,
        emails: item.signers.map((obj) => obj.email),
        ind_status: item.signers.map((obj) =>
          obj.signed ? "Signed" : "Not Signed"
        ),
        final_status: element.status,
      };
    });
    let temp_b = element.signers.map((item) => {
      return {
        groupOrInvidualName: item.name,
        emails: [item.email],
        ind_status: [item.signed ? "Signed" : "Not Signed"],
        final_status: element.status,
      };
    });
    buffer.push(...temp_a, ...temp_b);
    this.setState({ moreInfo: buffer });
  };
  enableMoreInfoOption = (value, record) => {
    let isRender;
    if (value == "PENDING" || value == "SENT_FOR_SIGNING") {
      isRender = true;
    } else {
      isRender = false;
    }
    const response = (
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>{value}</div>
        <div className={isRender ? "display-class" : "display-class-none"}>
          <Divider type="vertical" />
          <Button
            type="primary"
            onClick={() => this.setModalVisible(true, record)}
          >
            Signer's Info
          </Button>
        </div>
      </div>
    );

    const obj = {
      children: response,
      props: {},
    };
    return obj;
  };

  finalizeDataSource = () => {
    return this.props.dataSource.map((i) => {
      let buffer = [];
      let temp_a =
        i.groups == undefined
          ? [
              {
                groupOrInvidualName: null,
                emails: null,
                ind_status: null,
                final_status: null,
              },
            ]
          : i.groups.map((item) => {
              return {
                groupOrInvidualName: item.name,
                emails: item.signers.map((obj) => obj.email),
                ind_status: item.signers.map((obj) =>
                  obj.signed ? "Signed" : "Not Signed"
                ),
                final_status: i.status,
              };
            });

      let temp_b =
        i.signers == undefined
          ? [
              {
                groupOrInvidualName: null,
                emails: null,
                ind_status: null,
                final_status: null,
              },
            ]
          : i.signers.map((item) => {
              return {
                groupOrInvidualName: item.name,
                emails: [item.email],
                ind_status: [item.signed ? "Signed" : "Not Signed"],
                final_status: i.status,
              };
            });
      buffer.push(...temp_a, ...temp_b);
      return {
        date: i.date,
        hotel: i.hotel,
        Id: i.Id,
        status: i.status,
        groupOrInvidualName: buffer.map((i) => i.groupOrInvidualName).join(),
        emails: buffer.map((i) => i.emails).join(),
        ind_status: buffer.map((i) => i.ind_status).join(),
        final_status: buffer.map((i) => i.final_status).join(),
      };
    });
  };
  render() {
    let { sortedInfo } = this.state;
    sortedInfo = sortedInfo || {};
    const columnsMoreInfo = [
      {
        title: "Group/Individual",
        dataIndex: "groupOrInvidualName",
        key: "groupOrInvidualName",
        render: (value) => <p>{value}</p>,
      },
      {
        title: "Email",
        dataIndex: "emails",
        key: "emails",
        render: (value) => this.renderColumn(value),
      },
      {
        title: "Individual Status",
        dataIndex: "ind_status",
        key: "ind_status",
        render: (value) => this.renderColumn(value),
      },
      {
        title: "Final Status",
        dataIndex: "final_status",
        key: "final_status",
        render: (value) => <p>{value}</p>,
      },
    ];

    const columns = [
      {
        title: "Date",
        dataIndex: "date",
        key: "date",
        width: "20%",
        ...this.getColumnSearchProps("date"),
        sorter: (a, b) => moment(a.date).unix() - moment(b.date).unix(),
        sortOrder: sortedInfo.columnKey === "date" && sortedInfo.order,
      },
      {
        title: "Hotel Code",
        dataIndex: "hotel",
        key: "hotel",
        width: "30%",
        ...this.getColumnSearchProps("hotel"),
        sorter: (a, b) => a.hotel.length - b.hotel.length,
        sortOrder: sortedInfo.columnKey === "hotel" && sortedInfo.order,
      },
      {
        title: "ID",
        dataIndex: "Id",
        key: "Id",
        ...this.getColumnSearchProps("Id"),
        sorter: (a, b) => a.Id - b.Id,
        sortOrder: sortedInfo.columnKey === "Id" && sortedInfo.order,
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        ...this.getColumnSearchProps("status"),
        sorter: (a, b) => a.status.length - b.status.length,
        sortOrder: sortedInfo.columnKey === "status" && sortedInfo.order,
        render: (value, record) => this.enableMoreInfoOption(value, record),
      },
    ];

    var classes_Modal = "custom-envlp";
    var classes_Table =
      "is_table_3 custom-envlp-ext custom-header-table-signature-qc";

    return (
      <div>
        <Modal
          className={classes_Modal}
          title="Signature Pending"
          centered
          open={this.state.modalVisible}
          footer={[
            <Button key="back" type="primary" onClick={this.setModalClose}>
              Ok
            </Button>,
          ]}
        >
          <Table
            pagination={false}
            dataSource={this.state.moreInfo}
            columns={columnsMoreInfo}
          />
        </Modal>
        <div className={classes_Table}>
          {this.props.dataSource?.length > 0 ? <ExportCSV
            csvData={this.finalizeDataSource()}
            fileName={"TableResult"}
            columnNames={columns.concat(columnsMoreInfo)}
          /> : null}
          <Table
            className={"sm-custom-column-header"}
            bordered
            pagination={{
              total: this.state.sortedCount,
              showTotal: (total) => `Total ${total} items`,
              position: ["bottomRight"],
              showSizeChanger: true,
              showLessItems: true,
              defaultPageSize: 10,
              size: "small",
            }}
            onChange={this.onChangeTable}
            columns={columns}
            dataSource={this.props.dataSource}
          />
        </div>
      </div>
    );
  }
}

export default PaginatedDataTable;
